import { Pagination, PaginationProps } from 'antd'
import styles from './APagination.module.less'
import cls from 'classnames'

const COMPONENT_NAME = 'A-Pagination'

type Props = Pick<
  PaginationProps,
  'className' | 'style' | 'align' | 'current' | 'pageSize' | 'total' | 'onChange'
> & {
  testId?: string
}

function APagination(props: Props) {
  const { testId, className: propsClassName, ...paginationProps } = props
  const className = cls(styles[COMPONENT_NAME], propsClassName)
  return (
    <Pagination
      {...paginationProps}
      {...(testId ? { 'data-testid': testId } : {})}
      className={className}
      showSizeChanger={false}
    />
  )
}

export default APagination
